import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  wrap: {
    margin: '8px 0 16px',
    padding: '16px 0',
    borderTop: `1px solid ${customTheme.custom.black.B10}`,
    borderBottom: `1px solid ${customTheme.custom.black.B10}`,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      margin: '14px 0',
      padding: '14px 0',
    },
  },
  addressWrap: {
    marginBottom: '16px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '14px',
    },
  },
  addressTitle: {
    marginBottom: '2px',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '17px',
    color: customTheme.custom.black.B100,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: 0,
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
  address: {
    fontSize: '10px',
    lineHeight: '12px',
    color: customTheme.custom.black.B100,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      fontSize: '9px',
      lineHeight: '11px',
    },
  },
  addressDescription: {
    fontSize: '10px',
    lineHeight: '12px',
    color: customTheme.custom.black.B70,
  },
};
